(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ChartExportFile', ChartExportFile);

    ChartExportFile.$inject = ['$resource'];

    function ChartExportFile ($resource) {
        var resourceUrl =  'api/chart-export-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true, url: 'api/chart-export-files'},
        });
    }
})();
